module.exports = __webpack_public_path__ + "img/3_good_health_and_well-being.b31754dd.svg";